import React from "react";

import { useInput } from "../../../shared/hooks/form-fields";
import { Input, Textarea } from "../../../components/form-inputs/inputs";

const AddItem = (props) => {
    const nameInput = useInput("");
    const descInput = useInput("");

    const handleClick = async () => {
        const response = await props.addItem(nameInput.value, descInput.value);

        if (!response) {
            return;
        }

        nameInput.reset();
        descInput.reset();

        if (props.triggerUpdate) {
            props.triggerUpdate();
        }
    };

    return (
        <div>
            <Input name="name" label="Name" {...nameInput.bind} />
            <Textarea name="description" label="Description" {...descInput.bind} />
            <div className="button-group -right">
                <button className="button -primary" onClick={handleClick}>
                    {props.addText || "Add"}
                </button>
            </div>
        </div>
    );
};

export default AddItem;
